export default class GraphQLClient {

  headers = {
    'Accept': 'application/json',
  };

  initialize = ({ url, token }) => {
    this.url = url;
    this.token = token;
    if (this.token) {
      this.headers.Authorization = `Bearer ${this.token}`;
    }
  };

  query = (query, variables, binaryFiles) => {
    let headers;
    let body;
    variables = variables || {};

    if (binaryFiles) {
      body = this.makeFormData(query, variables, binaryFiles);
      headers = this.headers;
    }
    else {
      body = JSON.stringify({ query, variables });
      headers = {
        ...this.headers,
        'Content-Type': 'application/json',
      }
    }

    return fetch(this.url, {
      method: 'POST',
      headers,
      body,
    })
      .then(response => response.json())
      .then(response => {
        if (response.errors || !response.data) {
          throw response;
        }
        else {
          return response.data;
        }
      });
  };

  makeFormData = (query, variables, binaryFiles) => {
    const formData = new FormData();
    formData.append('query', query);
    formData.append('variables', JSON.stringify(variables));

    for (let fileName in binaryFiles) {
      formData.append(fileName, binaryFiles[fileName]);
    }
    return formData;
  };
}
